export const about = {
  // Hero
  heroLabel: 'About Us',
  heroTitleLine1: 'Passion for',
  heroTitleLine2: 'Live Music',
  heroDescription: 'We are the bridge between extraordinary talent and the events that deserve them. Since 2018, we have been connecting artists and audiences in the entertainment capital of the world.',

  // Stats
  statsArtists: 'Verified Artists',
  statsEvents: 'Events Served',
  statsYears: 'Years of Experience',
  statsGenres: 'Musical Genres',

  // Mission
  missionLabel: 'Our Mission',
  missionTitle: 'Connecting Talent with the Perfect Moment',
  missionDescription: 'We believe that every event deserves extraordinary music. Our mission is to discover, verify, and promote the best live music talent in Las Vegas, so event organizers can find the perfect artist for every occasion.',
  missionDescription2: 'From an intimate wedding to a corporate convention with thousands of attendees, we are here to ensure that the music is the highlight of the evening.',

  // Values
  valuesLabel: 'Our Values',
  valuesTitle: 'What Defines Us',
  value1Title: 'Quality',
  value1Description: 'Each artist in our directory passes through a strict verification process to ensure they meet the highest standards of professionalism and musical talent.',
  value2Title: 'Trust',
  value2Description: 'We build transparent relationships between artists and organizers. Every profile includes verified reviews, videos, and references.',
  value3Title: 'Passion',
  value3Description: 'Music is our life. We work with artists who share our passion for creating unforgettable live experiences.',
  value4Title: 'Diversity',
  value4Description: 'We celebrate all genres and styles. From jazz to electronic, from classical to Latin, we have the music that your event needs.',

  // Story
  storyLabel: 'Our Story',
  storyTitle: 'From an Idea to a Community',
  storyDescription: 'Piano Music Entertainment was born in 2018 from a simple need: the difficulty of finding reliable and quality musicians for events in Las Vegas. What started as a small directory of local artists has become the most complete talent platform in the city.',
  storyDescription2: 'Today we work with over 200 verified artists and have helped organize hundreds of events, from intimate weddings to corporate galas in the most exclusive venues of Las Vegas.',
  storyYear1: 'Founded',
  storyYear2: 'Artists',
  storyYear3: 'Events',
  storyYear4: 'Recognition',
  storyMilestone1: 'We started with 15 artists and a dream.',
  storyMilestone2: 'We reached 100 verified artists.',
  storyMilestone3: 'We exceeded 500 events served.',
  storyMilestone4: 'We won the Best Music Directory award in Las Vegas.',

  // CTA
  ctaTitle: 'Ready to Find the Perfect Talent?',
  ctaDescription: 'Browse our directory and discover the ideal artist for your next event.',
  ctaButton: 'Explore Artists',
  ctaButtonSecondary: 'Contact Us',
};

export default about;